var _style, _switch;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcLocation({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 20 20",
    viewBox: "0 0 20 20",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{opacity:0.7;}\n\t.st1{fill:#414142;}\n")), _switch || (_switch = /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("foreignObject", {
    width: 1,
    height: 1,
    requiredExtensions: "http://ns.adobe.com/AdobeIllustrator/10.0/"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "st0"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m10 3c-3.1 0-5.6 2.5-5.6 5.6 0 0.4 0 0.7 0.1 1.1v0.2c0.1 0.4 0.2 0.8 0.4 1.1 0.6 1.4 1.9 3.6 4.9 6h0.2c0.1 0 0.2 0 0.2-0.1 2.9-2.3 4.2-4.5 4.9-6 0.2-0.4 0.3-0.7 0.4-1.1v-0.2c0.1-0.3 0.1-0.7 0.1-1.1 0-3-2.5-5.5-5.6-5.5zm4.7 6.5v0.1c-0.1 0.3-0.2 0.6-0.3 1-0.5 1.3-1.8 3.3-4.4 5.5-2.6-2.2-3.8-4.1-4.4-5.5-0.1-0.3-0.2-0.6-0.3-1v-0.1c-0.1-0.3-0.1-0.6-0.1-0.9 0-2.7 2.2-4.8 4.8-4.8s4.8 2.2 4.8 4.8c0 0.3 0 0.6-0.1 0.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "m10 5.1c-2 0-3.6 1.6-3.6 3.6s1.6 3.5 3.6 3.5 3.6-1.6 3.6-3.6-1.6-3.5-3.6-3.5zm0 6.3c-1.5 0-2.8-1.2-2.8-2.8s1.3-2.7 2.8-2.7 2.8 1.2 2.8 2.8-1.3 2.7-2.8 2.7z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLocation);
export default __webpack_public_path__ + "static/media/ic_location.e989ddc2fd2bff84464166227e4b8e8b.svg";
export { ForwardRef as ReactComponent };